import collab from 'assets/images/collab.png';
import qa from 'assets/images/qa.png';
import jpass from 'assets/images/jpass.png';
import csp from 'assets/images/csp.png';

const getURLs = (platformConfig = {}) => ({
  collab: {
    name: 'Collab',
    src: collab,
    url: platformConfig.COLLAB_URL || '#',
  },
  jpass: {
    name: 'JPass',
    src: jpass,
    url: platformConfig.JPASS_URL || '#',
  },
  quality: {
    name: 'Quality',
    src: qa,
    url: platformConfig.QA_URL || '#',
  },
  csp: {
    name: 'CSP',
    src: csp,
    url: platformConfig.CSP_URL || '#',
  },
});

export default getURLs;
